<template>
    <div class="table-action-buttons">
        <i v-if="$can('create-milestones')"
           class="fa fa-clone fa-lg pointer"
           @click="confirmDuplication"
           :title="uLang('app.duplicate_type', { type: lang('app.milestone') })"
        ></i>
        <i v-if="$can('update-milestones')"
           class="fa fa-edit fa-lg pointer"
           @click="edit"
           :title="uLang('app.edit_type', { type: lang('app.milestone') })"
        ></i>
        <i v-if="$can('delete-milestones')"
           class="fa fa-trash fa-lg pointer"
           @click="confirmDestroy"
           :title="uLang('app.delete_type', { type: lang('app.milestone') })"
        ></i>
    </div>
</template>

<script>
    import {
        SuccessAlert,
        DestroyAlert,
        ErrorAlert,
        ConfirmationAlert
    } from "~/Swals";

    export default {
        name: 'actions',

        props: ['data', 'index'],

        methods: {
            /**
             * Double check if they want to delete this milestone
             */
            confirmDestroy() {
                new DestroyAlert({ entity: this.lang('app.milestone') })
                    .show()
                    .then(async () => {
                        this.destroy()
                    });
            },

            /**
             * Actually send the request to try to delete the milestone.
             */
            destroy() {
                window.axios.delete(route('trajectory-projects.trajectories.milestones.destroy', {
                    trajectory_project: this.data.trajectory.trajectory_project_id,
                    trajectory: this.data.trajectory_id,
                    milestone: this.data.id
                })).then(({ data }) => {
                    new SuccessAlert({
                        title: this.data.name,
                        text: this.uLang('app.entity_removed', {entity: this.lang('app.milestone')})
                    }).show();

                    window.vue.$emit('reloadTable');
                }).catch(({ response }) => {
                    if (response.status == 422) {
                        new ErrorAlert({ text: response.data.message }).show();
                    }
                });
            },

            /**
             * Double check if they really want to duplicate this milestone
             */
            confirmDuplication() {
                new ConfirmationAlert({ text: this.uLang('app.duplicate_milestone_confirmation') })
                    .show()
                    .then(async () => {
                        this.duplicate()
                    });
            },

            /**
             * Duplicate the milestone, then navigate to the edit page of the milestone.
             */
            async duplicate() {
                let { data } = await window.axios.post(route('trajectory-projects.trajectories.milestones.duplicate', {
                    trajectory_project: this.data.trajectory.trajectory_project_id,
                    trajectory: this.data.trajectory_id,
                    milestone: this.data.id
                }));

                this.$router.push({
                    name: 'admin.trajectory_projects.trajectories.milestones.edit',
                    params: {
                        projectId: this.data.trajectory.trajectory_project_id,
                        trajectoryId: this.data.trajectory_id,
                        id: data.id
                    }
                });
            },

            /**
             * Go to the edit page.
             */
            edit() {
                this.$router.push({
                    name: 'admin.trajectory_projects.trajectories.milestones.edit',
                    params: {
                        projectId: this.data.trajectory.trajectory_project_id,
                        trajectoryId: this.data.trajectory_id,
                        id: this.data.id
                    }
                })
            },
        }
    }
</script>

<style lang="scss" scoped>
</style>